<template>
  <div id="introduction">
    <div class="card shadow mb-4">
      <div class="card-header bg-transparent">
        <div class="row align-items-center">
          <div class="col">
            <h6 class="text-uppercase text-muted ls-1 mb-1">Tackling Blight</h6>
            <h2 class="mb-0">Featured Rehab</h2>
          </div>
        </div>
      </div>
      <div class="card-body">
        <image-compare :before="afterImage" :after="beforeImage" class="mb-4">
          <i class="fa fa-angle-left" aria-hidden="true" slot="icon-left"></i>
          <i class="fa fa-angle-right" aria-hidden="true" slot="icon-right"></i>
        </image-compare>
        <p>This Dunkirk home was acquired as a bank foreclosure in 2017 by the Land Bank. It had been vacant for 4+ years. The purchaser completed the renovation with reverence to the home’s period details and family-friendly design. The home was resold to a young family as their first home, and the neighborhood is thrilled with the relief of the blighted eyesore on their block.</p>
      </div><!-- /.card-body -->
    </div><!-- /.card -->

<!-- STATS SECTION -->
<!--
<div class="row mb-4">
  <div class="col-md-3 pr-0">
    <div class="card card-stats mt-2 mb-4 mb-xl-0">
      <div class="card-body">
        <div class="row">
          <div class="col">
            <h5 class="card-title text-uppercase text-muted mb-0">Jamestown Demos</h5>
            <span class="h4 mb-0">Goal: 30</span><br>
            <span class="h4 mb-0">Demolished: 59</span>
          </div>
          <div class="col-auto">
            <div class="icon icon-shape bg-success text-white rounded-circle shadow">
              <i class="fas fa-chart-bar"></i>
            </div>
          </div>
        </div>
        <p class="mt-3 mb-0 text-muted text-sm">
          <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 197%</span>
          <span class="text-nowrap">Achievement Rate</span>
        </p>
      </div>
    </div>
  </div>
  <div class="col-md-3 pr-0">
    <div class="card card-stats mt-2 mb-4 mb-xl-0">
      <div class="card-body">
        <div class="row">
          <div class="col">
            <h5 class="card-title text-uppercase text-muted mb-0">Dunkirk Demos</h5>
            <span class="h4 font-weight-bold mb-0">Goal: 15</span><br>
            <span class="h4 font-weight-bold mb-0">Demolished: 10</span>
          </div>
          <div class="col-auto">
            <div class="icon icon-shape bg-danger text-white rounded-circle shadow">
              <i class="fas fa-chart-bar"></i>
            </div>
          </div>
        </div>
        <p class="mt-3 mb-0 text-muted text-sm">
          <span class="text-danger mr-2"><i class="fas fa-arrow-down"></i> 67%</span>
          <span class="text-nowrap">Achievement Rate</span>
        </p>
      </div>
    </div>
  </div>
  <div class="col-md-3 pr-0">
    <div class="card card-stats mt-2 mb-4 mb-xl-0">
      <div class="card-body">
        <div class="row">
          <div class="col">
            <h5 class="card-title text-uppercase text-muted mb-0">Rural Demos</h5>
            <span class="h4 font-weight-bold mb-0">Goal: 9</span><br>
            <span class="h4 font-weight-bold mb-0">Demolished: 13</span>
          </div>
          <div class="col-auto">
            <div class="icon icon-shape bg-success text-white rounded-circle shadow">
              <i class="fas fa-chart-bar"></i>
            </div>
          </div>
        </div>
        <p class="mt-3 mb-0 text-muted text-sm">
          <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 145%</span>
          <span class="text-nowrap">Achievement Rate</span>
        </p>
      </div>
    </div>
  </div>
  <div class="col-md-3 pr-0">
    <div class="card card-stats mt-2 mb-4 mb-xl-0">
      <div class="card-body">
        <div class="row">
          <div class="col">
            <h5 class="card-title text-uppercase text-muted mb-0">Mixed-Use Demos</h5>
            <span class="h4 font-weight-bold mb-0">Goal: 7</span><br>
            <span class="h4 font-weight-bold mb-0">Demolished: 8</span>
          </div>
          <div class="col-auto">
            <div class="icon icon-shape bg-success text-white rounded-circle shadow">
              <i class="fas fa-chart-bar"></i>
            </div>
          </div>
        </div>
        <p class="mt-3 mb-0 text-muted text-sm">
          <span class="text-success mr-2"><i class="fas fa-arrow-up"></i> 114%</span>
          <span class="text-nowrap">Achievement Rate</span>
        </p>
      </div>
    </div>
  </div>
</div><!-- /.row -->
<!-- END STATS SECTION -->

    <div class="row">
      <!-- Letter from the Director -->
      <div class="col-md-8">
        <div class="card shadow">
          <div class="card-header bg-transparent">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="text-uppercase text-muted ls-1 mb-1">Letter from the Director</h6>
                <h2 class="mb-0">Gina Paradis</h2>
              </div>
            </div>
          </div>
          <div class="card-body">

            <p>2018 – Wow; how quickly a year can fly by. Each year seems to get busier and shorter as we expand our programming, take on new challenges, and forge a new path towards community renewal, improved housing stock and stronger neighborhoods.</p>
            <p>In the past year, we commenced a pilot program called Neighbors for Neighborhoods, a rental rehab program meant to cultivate responsible local landlords; we deepened our commitment to heightening the standards of affordable housing through our local and county-wide partnerships; we collaborated with communities to resolve complicated and/or long-standing issues of blight; and continued to enhance the efficiency of our operations.</p>
            <p>While we accomplished much in 2018, it was also an unsettling year, in which we struggled to plan without an assurance of funding stability until late in the 3rd quarter of the year. Fortunately, we were able to secure a $2million grant via the State Attorney General’s office, via settlement funds from the mortgage crisis. This will provide support for our program through 2020, however the need for predictable funding continues.  Land Banks have a proven track record, in the state and through-out the country, of being a highly effective tool in community development and neighborhood revitalization. Land Banks tackle the most distressed and derelict properties in their communities; these public burdens will not be alleviated with simple real estate transfers; they require intervention that the market cannot or will not provide. If Land Banks are to succeed in intervening in destabilized neighborhood conditions, helping to ensure quality affordable housing, and remedying the negative impacts produced by the dregs of the housing market, funding support from the State of NY needs to be budgeted.</p>

            <p>We wish to thank our partners, including LISC (Local Initiatives Support Corporation), Enterprise Community Partners, Inc., the New York State Attorney General’s office, the Chautauqua County Legislature, our local municipal leaders, county and local housing champions, and all of those individuals who have supported our efforts through their purchases, partnerships, and voices. Sharing our mission, expanding our reach, engaging more stakeholders as we tackle the issues of blight in Chautauqua County will continue to be our focus in 2019. We hope you will join us in making neighborhood safe and strong in the coming year!</p>


            <p>Sincerely,</p>
            <p class="lead">Gina Paradis</p>

          </div>
        </div>
      </div><!-- /.col-md-8 -->
      <div class="col-md-4">
        <div class="card shadow">
          <div class="card-body">
            <img width="100%" src="https://firebasestorage.googleapis.com/v0/b/cclbc-annual-report-2018.appspot.com/o/images%2FGina%20Color%201.jpg?alt=media&token=808a8a64-c935-4c2a-b65b-1dd1b4c657a2">
          </div><!-- /.card-body -->
        </div><!-- /.card .shadow -->

    </div>
    </div><!-- /.row -->
  </div><!-- /#Introduction -->
</template>

<script>
export default {
  data() {
    return {
      beforeImage: 'https://firebasestorage.googleapis.com/v0/b/cclbc-annual-report-2018.appspot.com/o/images%2Fbefore.jpg?alt=media&token=b823e8e3-27e5-431c-8414-396f17518e3e',
      afterImage: 'https://firebasestorage.googleapis.com/v0/b/cclbc-annual-report-2018.appspot.com/o/images%2Fafter.jpg?alt=media&token=7c953091-1b9f-40dd-ba1e-afcee736c809'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Introduction.vue